import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import blockService from './blockService';

// Get user from

const initialState = {
  headingBlock: '',
  headingError: false,
  headingSuccess: false,
  headingLoading: false,
  headingErrorMsg: '',

  // share block
  shareUserState: '',
  shareUserSuccess: false,
  shareUserError: false,
  shareUserLoading: false,
  shareUserErrMsg: '',
};

export const creatingHeadingBlock = createAsyncThunk(
  'headingBlock/creatingHeadingBlock',

  async (headingkData, thunkAPI) => {
    try {
      const response = await blockService.creatingHeadingBlock(headingkData);
      return response;
    } catch (error) {
      const headingErrorMsg =
        (error.response && error.response.data && error.response.data.headingErrorMsg) ||
        error.headingErrorMsg ||
        error.toString();
      return thunkAPI.rejectWithValue(headingErrorMsg);
    }
  }
);
export const creatingShareBlock = createAsyncThunk(
  'shareBlock/creatingShareBlock',

  async (data, thunkAPI) => {
    try {
      return await blockService.creatingShareBlock(data);
    } catch (error) {
      const errorMsg =
        (error.response && error.response.data && error.response.data.errorMsg) || error.errorMsg || error.toString();
      return thunkAPI.rejectWithValue(errorMsg);
    }
  }
);
export const blockSlice = createSlice({
  name: 'headingBlock',
  initialState,
  reducers: {
    resetUser: (state) => {
      state.headingLoading = false;
      state.headingSuccess = false;
      state.headingError = false;
      state.headingErrorMsg = '';

      state.shareUserLoading = false;
      state.shareUserState = false;
      state.shareUserSuccess = false;
      state.shareUserError = false;

      state.shareUserErrMsg = '';
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(creatingHeadingBlock.pending, (state) => {
        state.headingLoading = true;
      })
      .addCase(creatingHeadingBlock.fulfilled, (state, action) => {
        state.headingLoading = false;
        state.headingSuccess = true;
        state.headingBlock = action.payload;
      })
      .addCase(creatingHeadingBlock.rejected, (state, action) => {
        state.headingLoading = false;
        state.headingError = true;
        state.headingErrorMsg = action.payload; // error from catch will come here via action.payload and update headingErrorMsg
      })
      // create share block
      .addCase(creatingShareBlock.pending, (state) => {
        state.shareUserLoading = true;
      })
      .addCase(creatingShareBlock.fulfilled, (state, action) => {
        state.shareUserLoading = false;
        state.shareUserSuccess = true;
        state.shareUserState = action.payload;
      })
      .addCase(creatingShareBlock.rejected, (state, action) => {
        state.shareUserLoading = false;
        state.shareUserError = true;
        state.shareUserErrMsg = action.payload;
      });
  },
});

export const { resetUser } = blockSlice.actions;
export default blockSlice.reducer;
